import { createContext } from "react";

export const LanguageContext = createContext({lang: '', setLang: (lang: string) => {} });